import React, { ReactNode } from 'react'

import { DialogProps } from '@mui/material'

import * as S from './ana-dialog.styles'

export const AnaDialog = ({
  title,
  children,
  actions,
  ...rest
}: DialogProps & { title: string; actions: ReactNode }) => (
  <S.Root {...rest}>
    <S.DialogTitle>{title}</S.DialogTitle>
    <S.DialogContent>{children}</S.DialogContent>
    <S.DialogActions>{actions}</S.DialogActions>
  </S.Root>
)
